import configs from '@/plugins/configs.js';

export default {
    install(Vue) {
        Vue.prototype.$configs = configs;
    },
};
